import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const imgUrl = (p) => p?.startsWith("http") ? p : `${BACKEND}${p}`;

const CAT_LABEL = {
    gastronomie: "Gastronomie",
    nature: "Nature",
    culture: "Culture",
    "bien-etre": "Bien-être",
    artisan: "Artisan",
    spiritueux: "Spiritueux",
    sport: "Sport & nautisme",
};

export default function ExperienceCard({ experience: xp, index = 0, variant = "default" }) {
    const img = imgUrl(xp.image);
    const isRealPhoto = xp.image && (xp.image.includes('/static/img/real/') || xp.image.includes('/static/img/dream/'));
    const imgClass = isRealPhoto ? "cp-photo-real" : "cp-photo-warm";
    const verifiedBadge = xp.verified && (
        <span className="inline-flex items-center gap-1 cp-tiny text-[10px] text-cp-foret border border-cp-foret/40 px-1.5 py-0.5 uppercase tracking-widest" title={xp.official_name || ""}>
            <span className="w-1 h-1 rounded-full bg-cp-foret" /> Vérifié
        </span>
    );

    if (variant === "feature") {
        return (
            <Link to={`/experiences/${xp.slug}`} data-testid={`xp-card-feature-${xp.slug}`} className="group block">
                <div className="cp-image-zoom aspect-[4/5] bg-cp-craie mb-6 overflow-hidden">
                    <img src={img} alt={xp.title} loading="lazy" className={`w-full h-full object-cover object-center ${imgClass}`} />
                </div>
                <div className="flex items-center gap-3 mb-3">
                    <p className="cp-tiny text-cp-sable-deep">
                        N°{String(index + 1).padStart(2, "0")} · {CAT_LABEL[xp.category] || xp.category}
                    </p>
                    {verifiedBadge}
                </div>
                <h3 className="cp-serif text-2xl md:text-3xl leading-tight text-cp-encre group-hover:italic transition-all mb-3">
                    {xp.title}
                </h3>
                <p className="cp-serif italic text-base text-cp-gris leading-snug max-w-md mb-4">{xp.tagline}</p>
                <p className="cp-tiny text-cp-gris">{xp.duration} · {xp.group_size}{xp.price_from ? ` · à partir de ${xp.price_from}` : ""}</p>
            </Link>
        );
    }

    return (
        <Link to={`/experiences/${xp.slug}`} data-testid={`xp-card-${xp.slug}`} className="group block">
            <div className="cp-image-zoom aspect-[4/5] bg-cp-craie mb-5 overflow-hidden">
                <img src={img} alt={xp.title} loading="lazy" className={`w-full h-full object-cover object-center ${imgClass}`} />
            </div>
            <div className="flex items-center gap-3 mb-2">
                <p className="cp-tiny text-cp-sable-deep">
                    N°{String(index + 1).padStart(2, "0")} · {CAT_LABEL[xp.category] || xp.category}
                </p>
                {verifiedBadge}
            </div>
            <h3 className="cp-serif text-xl md:text-2xl leading-snug text-cp-encre group-hover:italic transition-all">
                {xp.title}
            </h3>
            <p className="cp-serif italic text-base text-cp-gris mt-2 leading-snug max-w-md">{xp.tagline}</p>
            <p className="cp-tiny text-cp-gris mt-4">{xp.duration}{xp.price_from ? ` · ${xp.price_from}` : ""}</p>
        </Link>
    );
}
